// extracted by mini-css-extract-plugin
export default {"share_hb":"index_share_hb_os8u7","close":"index_close_ANFV8","tip":"index_tip_fQbn7","mask":"index_mask_RvcFv"};